import { useContext, useState } from 'react';
import { Link, CardHeader, CardContent, TextField, Grid, Typography, MenuItem, Button, CircularProgress, Table, TableHead, TableRow, TableCell, TableBody, TableFooter } from '@material-ui/core';
import { dealerContext } from './DealerContext';
import { applicationContext } from 'helpers/services';
import { Autocomplete } from '@material-ui/lab';
import { FilterContainer } from 'components';


let Customer = () => {
    let service = useContext(dealerContext);
    let appService = useContext(applicationContext);

    let [searchText, setSearchText] = useState('');


    let chooseFakeDealer = () => {
        let { search } = service;

        service.chooseDealer({
            ...search,
            country: search.countryCode,
            name: search.name !== '' ? search.name : 'Other',
            plainAddress: `(${service.search.countryCode}) - ${search.storeTypeSearch}`,
            address: '',
            id: '',
            url: '',
            state: '',
            shipToCountries: [],
        })
    }


    return (
        <>
            <CardHeader
                disableTypography
                title={<Typography variant="h4">Dealer information</Typography>}
            />
            <CardContent>
                <FilterContainer onSubmit={() => service.searchDealers()}>
                    <Grid item xs>
                        <TextField
                            label="Dealer Name"
                            variant="outlined"
                            value={service.search.name}
                            onChange={(e: any) => service.updateSearch({
                                ...service.search,
                                name: e.target.value
                            })}
                        />
                    </Grid>
                    <Grid item xs>
                        <Autocomplete
                            inputValue={searchText}
                            value={service.search.countryCode}
                            onInputChange={(event, newInputValue) => setSearchText(newInputValue)}
                            getOptionLabel={(option) => appService.countries.getValueByKey(option)}
                            options={appService.countries.map(x => x.key)}
                            onChange={(e: any, value) => service.updateSearch({
                                ...service.search,
                                countryCode: value || ''
                            })}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            select
                            variant="outlined"
                            label="Dealer Type"
                            value={service.search.storeTypeSearch}
                            onChange={(e: any) => service.updateSearch({
                                ...service.search,
                                storeTypeSearch: e.target.value
                            })}
                        >
                            <MenuItem value="retail">Retail</MenuItem>
                            <MenuItem value="online">Online</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item>
                        <Button
                            type="submit"
                            color="secondary"
                            variant="contained"
                            disabled={service.isSearching}
                        >
                            {service.isSearching && <CircularProgress size={20} />}&nbsp;Find Dealer
                        </Button>
                    </Grid>
                </FilterContainer>

                {service.isSearchDone &&
                    <>
                        <div style={{ marginBottom: 16 }}>
                            {service.selectedDealer &&
                                <Typography variant="h5">
                                    Dealer:&nbsp;{service.selectedDealer.name}&nbsp;{service.selectedDealer.plainAddress}&nbsp;&nbsp;
                                    <Link
                                        component="button"
                                        variant="h5"
                                        style={{ verticalAlign: 'unset' }}
                                        onClick={() => service.chooseDealer(undefined)}
                                    >
                                        choose other
                                    </Link>
                                </Typography>
                            }
                            {!service.selectedDealer &&
                                <Typography variant="h5">
                                    Dealer not in the list? Write the name of the dealer in the 'Dealer name' field and&nbsp;&nbsp;
                                    <Link
                                        component="button"
                                        variant="h5"
                                        style={{ verticalAlign: 'unset' }}
                                        onClick={chooseFakeDealer}
                                    >
                                        continue
                                    </Link>
                                </Typography>
                            }
                        </div>

                        {!service.selectedDealer &&
                            <div style={{ maxHeight: 500, overflow: 'auto' }}>
                                {service.dealers.length === 0 && <Typography>No dealers were found</Typography>}
                                {service.dealers.length > 0 &&
                                    <>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Store Name</TableCell>
                                                    <TableCell>Address</TableCell>
                                                    {service.search.storeTypeSearch === "retail" &&
                                                        <TableCell>City</TableCell>
                                                    }
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {service.dealers.map((dealer, index) =>
                                                    <TableRow key={index} selected={service.selectedDealer?.id === dealer.id}>
                                                        <TableCell style={{ cursor: 'pointer' }} onClick={() => service.chooseDealer(dealer)}>{dealer.name}</TableCell>
                                                        <TableCell>{dealer.address}</TableCell>
                                                        {service.search.storeTypeSearch === "retail" &&
                                                            <TableCell>{dealer.city}</TableCell>
                                                        }
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                            <TableFooter>
                                                { }
                                            </TableFooter>
                                        </Table>
                                    </>
                                }
                            </div>
                        }
                    </>
                }
            </CardContent>
        </>
    )
}

export default Customer;